export const TEST_CHALLENGE_SLUG = 'test-your-english-level';